import { render } from "./AdminAuditLogs.vue?vue&type=template&id=745bbf41&scoped=true"
import script from "./AdminAuditLogs.vue?vue&type=script&lang=js"
export * from "./AdminAuditLogs.vue?vue&type=script&lang=js"

import "./AdminAuditLogs.vue?vue&type=style&index=0&id=745bbf41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745bbf41"]])

export default __exports__